import React, { useState, useEffect} from "react";
import axios from "../utils/axios";
import { useParams } from "react-router-dom";
import { getItenary } from '../api/commerce';
import Loading from '../components/loading/Loading';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';


export default function ContactForm() {
  const { itemId } = useParams();
  const [receiverId, setReceiverId] = useState("")
  const [receiverMobile, setReceiverMobile] = useState("")
  const [consoleError, setConsoleError] = useState("");
  const [loading, setLoading] = useState(true);
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [status, setStatus] = useState("");
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();


  useEffect(() => {
    if (!itemId) return;  

    setLoading(true);  
    getItenary(itemId)
      .then(res => {
        setReceiverId(res.owner_id);
        setReceiverMobile(res);
      })
      .catch(err => {
        setReceiverId(null);  
      })
      .finally(() => {
        setLoading(false); 
      });
  }, [itemId]); 
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post("messages/", {
        receiver: receiverId,
        prodId: itemId,
        subject,
        body,
      });
      setStatus(setlang==="en"?"Message sent!":"پیام ارسال شد");
      setSubject("");
      setBody("");
      
    } catch (error) {
        if (error.response) {
          setConsoleError("Send failed:", error.response.status, error.response.data);
        } else {
          setConsoleError("Send failed:", error.message);
        }
        setStatus(setlang==="en"?"Failed to send message":"در ارسال پیام مشکلی رخ داد");
      }
  };

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])
  
  if (loading) return <Loading />;  
  return (
    <>
      <NavbarLog />
      <div className="reg-page">
        <div className="registration-container">
          <h2 className="registration-heading">{setlang === "en" ? "Contact Form" : "فرم تماس"}</h2>
          <form onSubmit={handleSubmit} className={setlang === "en" ? "form-group" : "form-group-fa" }>
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder={setlang === "en" ? "Subject" : "عنوان" }
            />
            <textarea
              style={{ 
                width: "100%", 
                height: "250px", 
                padding: "10px", 
                resize: "vertical", 
                overflowX: "auto",
                fontSize:'1rem',
                marginBottom:'1rem',
                border: '1.5px solid #ddddddba',
                borderRadius: '8px',
              }}
              placeholder={setlang === "en" ? "Your message..." : " ..... پیام شما برای ما"}
              value={body}
              onChange={(e) => setBody(e.target.value)}
            />
            <button  className='contact-submit' type="submit">
              {setlang === "en" ? "Send" : "ارسال"}
            </button>
          </form>
          {status && <p style={{color:"#33a495"}}>{status}</p>}
        </div>
      </div>
      <Footer />
    </>
  );
}
